<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>A expansão continua</h2>
          <p>
            A JBS adquire a <strong>Tatiara Meats</strong> e os ativos da
            <strong>Rockdale Beef</strong>, na Austrália, e o
            <strong>Grupo Toledo</strong>, na Bélgica. Também anuncia a
            aquisição do confinamento <strong>McElhaney</strong> nos Estados
            Unidos, e amplia sua participação na
            <strong>Pilgrim’s Pride</strong> para 67,27%. Realiza em abril e
            maio uma oferta pública primária de 200 milhões de ações ordinárias.
          </p>
          <img
            src="../assets/img/2010/2010-1.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2010/06/10/g/20100610-42604-spo-40-eco-b16-not-sqhhqkg.jpg'
              )
            "
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2010/2010-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2011/03/07/g/20110307-42874-spo-46-eco-n4-not-qkhhpwg.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2010/2010-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2012/04/10/g/20120410-43274-nac-28-eco-b13-not-swghpge.jpg'
              )
            "
            class="secondItem"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Comida pra fotografar: surge o <strong>Instagram</strong></h2>
          <p>
            Lançado em 2010 pelo americano Kevin Systrom e o brasileiro Mike
            Krieger, um aplicativo de fotos começava a dar o que falar: com
            filtros espertos e uma camada de rede social, o
            <strong>Instagram</strong> virou uma febre já em seus primeiros
            meses. Entre os principais conteúdos publicados, estavam fotos de
            refeições e alimentos.
          </p>
          <blockquote>
            As mídias sociais influenciam hábitos de consumo e moldam a formação
            da cultura alimentar da atualidade”,
            <span>afirma o professor</span> Fábio Bitelli
          </blockquote>
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 375px 280px 300px;
    gap: 40px;
    justify-content: space-between;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 20px;
      }
      &--image {
        position: relative;
        @include media('<=desktop') {
          padding: 0 20px 20px;
          margin-top: -50px;
        }

        span {
          position: absolute;
          left: 0px;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media('<=desktop') {
          padding: 20px;
          background: color(cGreen);
          position: relative;
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue4);
          @include media('<=desktop') {
            position: absolute;
            top: -50px;
            width: initial;
          }

          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
            @include media('<=desktop') {
              top: initial;
              position: initial;
            }
          }
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: color(cGreen);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
